﻿/**
 * <image-loader> — 子图片加载完成后给组件加上 loaded 属性。
 * 通过 snippets/header-script.liquid 全站加载一次。
 *
 * @example
 * {% render 'image-loader', image: section.settings.pc_img, class: 'pc-show' %}
 */
(function () {
  "use strict";

  if (customElements.get("image-loader")) return;

class ImageLoader extends HTMLElement {
  connectedCallback() {
    const img = this.querySelector("img");

    if (!img) return;

    const handleLoad = () => {
      this.setAttribute("loaded", "");
      img.removeEventListener("load", handleLoad);
    };

    if (img.complete && img.naturalWidth > 0) {
      this.setAttribute("loaded", "");
      return;
    }

    img.addEventListener("load", handleLoad);
  }
}

  customElements.define("image-loader", ImageLoader);
})();
